
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import { Tag } from "@/generated/graphql";
import DropdownOption from "@/entities/DropdownOption";
import InputPlaceholder from "@/components/skeletonPlaceholder/components/InputPlaceholder.vue";
import GET_TAGS from "@/apollo/tag/GetTags.gql";
import { mount } from "@vue/test-utils";

@Component({
  components: {
    InputPlaceholder,
    DropdownFilter,
  },
  apollo: {
    tags: {
      query: GET_TAGS,
      variables() {
        if (this.selectedTagId !== undefined) {
          return {};
        } else {
          return null;
        }
      },
      watchQuery: true,
      update(data: { tag: Tag[] }) {
        this.isDataLoaded = true;
        const tags = data.tag;
        return tags;
      },
    },
  },
})
export default class TagMultiSelectEmployee extends Vue {
  @Prop({ type: String, default: undefined }) selectedTagId!: string[];
  @Prop({ type: String, default: 3 }) readonly max?: number;
  @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

  tags: Tag[] = [];
  selectedTag: DropdownOption[] = [];
  isDataLoaded = false;

  get tagsLoaded(): boolean {
    return this.tags.length > 0;
  }

  @Watch("tags", { immediate: true, deep: true })
  onTagsChanged(): void {
    this.handleSelectedTagUpdate();
  }

  private handleSelectedTagUpdate(): void {
    if (
      this.isDataLoaded &&
      this.selectedTagId !== undefined &&
      this.selectedTagId.length > 0
    ) {
      const selectedTags = this.tags.filter((tag) =>
        this.selectedTagId.includes(tag.id)
      );

      this.selectedTag = selectedTags.map((tag) => ({
        name: tag.name,
        id: tag.id,
      }));
    }
  }

  update(selectedTags: DropdownOption[]): void {
    this.selectedTag = selectedTags;

    if (!selectedTags.length) {
      return;
    }

    this.$emit("input", selectedTags[0].id);
  }
}
